import { createORPCClient } from "@orpc/client";
import { RPCLink } from "@orpc/client/fetch";
import type { RouterClient } from "@orpc/server";
import { type } from "arktype";

import type { API } from "@/api/router";

const link = new RPCLink({
	url: new URL("/rpc", window.location.origin).href,
});

export const api: RouterClient<API> = createORPCClient(link);
export type SugarReceivable = Awaited<ReturnType<typeof api.metrics.sugarReceivable>>;

const operatorSchema = type({
	id: "string",
	name: "string",
	email: "string.email",
});

export async function fetchCurrentOperator() {
	const response = await fetch("/api/me", { headers: { accept: "application/json" } });
	const body: unknown = await response.json();

	if (!response.ok) {
		throw new Error(
			type({ error: "string" }).allows(body)
				? body.error
				: "Não foi possível confirmar seu acesso.",
		);
	}

	return operatorSchema.assert(body);
}
